import React from "react";
import {
  Box,
  Flex,
  Image,
  Link,
  Text,
  IconButton,
  VStack,
  HStack,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  useDisclosure,
  useColorModeValue,
  Icon,
  Divider
} from "@chakra-ui/react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { FaBars, FaHome, FaInfoCircle, FaCogs, FaEnvelope, FaPhone, FaClock, FaLinkedin, FaFacebook, FaWhatsapp } from "react-icons/fa";

// Path to your logo image
const img = "./orivant.jpeg";

function NavbarTopSecond() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const location = useLocation();
  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  const isActive = (path) => {
    // Handle the Services offered page specifically
    if (path === "/Services offered") {
      return location.pathname === "/Services%20offered" || 
             location.pathname === "/Services offered" || 
             location.pathname === "/services";
    }
    return location.pathname === path;
  };

  const navItems = [
    { path: "/", label: "Home", icon: FaHome },
    { path: "/about", label: "About", icon: FaInfoCircle },
    { path: "/Services offered", label: "Services offered", icon: FaCogs },
    { path: "/contact", label: "Contact", icon: FaEnvelope },
  ];

  return (
    <Box
      position="fixed"
      top="40px"
      left={0}
      right={0}
      zIndex={1000}
      bg={bgColor}
      boxShadow="sm"
      fontSize="14px"
      width="100%"
      height="90px"
      borderBottom="1px solid"
      borderColor={borderColor}
    >
      {/* Desktop View */}
      <Flex
        justifyContent="space-between"
        maxWidth="80%"
        mx="auto"
        alignItems="center"
        height="100%"
        display={{ base: 'none', md: 'flex' }}
      >
        {/* Logo - Desktop */}
        <RouterLink to="/">
          <Flex alignItems="center" cursor="pointer">
            <Image
              boxSize="50px"
              objectFit="contain"
              src={img}
              alt="tech logo"
            />
          </Flex>
        </RouterLink>

        {/* Navigation Links - Desktop */}
        <Flex alignItems="center" justifyContent="space-between" w="30%">
          {navItems.map((item) => (
            <Text
              key={item.path}
              p={3}
              position="relative"
              _after={{
                content: '""',
                position: "absolute",
                bottom: "0",
                left: "50%",
                transform: "translateX(-50%)",
                width: isActive(item.path) ? "100%" : "0",
                height: "2px",
                bg: "blue.500",
                transition: "width 0.3s ease",
              }}
              _hover={{
                _after: {
                  width: "100%",
                },
              }}
            >
              <RouterLink
                to={item.path}
                style={{
                  color: isActive(item.path) ? "#2B6CB0" : "#000000",
                  textDecoration: "none",
                  fontWeight: isActive(item.path) ? "600" : "normal",
                }}
              >
                {item.label}
              </RouterLink>
            </Text>
          ))}
        </Flex>
      </Flex>

      {/* Mobile View */}
      <Flex
        justifyContent="space-between"
        alignItems="center"
        height="100%"
        px={4}
        display={{ base: 'flex', md: 'none' }}
      >
        {/* Logo - Mobile */}
        <RouterLink to="/">
          <Image
            boxSize="40px"
            objectFit="contain"
            src={img}
            alt="tech logo"
            cursor="pointer"
          />
        </RouterLink>

        {/* Burger Icon - Mobile */}
        <IconButton
          aria-label="Open Menu"
          icon={<FaBars />}
          onClick={onOpen}
          size="md"
          variant="ghost"
          colorScheme="gray"
        />

        {/* Mobile Menu Drawer */}
        <Drawer
          isOpen={isOpen}
          placement="right"
          onClose={onClose}
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader borderBottomWidth="1px">Navigation</DrawerHeader>
            <DrawerBody>
              <VStack spacing={6} align="stretch">
                {navItems.map((item) => (
                  <RouterLink
                    key={item.path}
                    to={item.path}
                    onClick={onClose} // Close drawer on link click
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    <HStack
                      spacing={3}
                      p={3}
                      borderRadius="md"
                      bg={isActive(item.path) ? "blue.50" : "transparent"}
                      color={isActive(item.path) ? "blue.500" : "gray.700"}
                      _hover={{
                        bg: "blue.100",
                        color: "blue.600",
                      }}
                      transition="all 0.2s ease-in-out"
                    >
                      <Icon as={item.icon} />
                      <Text fontWeight={isActive(item.path) ? "600" : "normal"}>
                        {item.label}
                      </Text>
                    </HStack>
                  </RouterLink>
                ))}

                {/* Contact Info from NavbarTopFirstt */}
                <Divider />
                <Text fontSize="sm" fontWeight="bold" color="gray.500">Contact Info</Text>
                <VStack spacing={3} align="stretch">
                  {/* Phone Link */}
                  <Link href="tel:+919473421755" style={{ textDecoration: "none" }}>
                    <HStack spacing={3} color="gray.700" _hover={{ color: 'blue.500' }}>
                      <Icon as={FaPhone} color="gray.500" />
                      <Text fontSize="sm">+91 9473421755</Text>
                    </HStack>
                  </Link>
                  {/* Email Link */}
                  <Link href="mailto:partners@orivanta.ai" style={{ textDecoration: "none" }}>
                    <HStack spacing={3} color="gray.700" _hover={{ color: 'blue.500' }}>
                      <Icon as={FaEnvelope} color="gray.500" />
                      <Text fontSize="sm">partners@orivanta.ai</Text>
                    </HStack>
                  </Link>
                   {/* WhatsApp Link */}
                   <Link href="https://wa.me/9473421755" isExternal style={{ textDecoration: "none" }}>
                    <HStack spacing={3} color="gray.700" _hover={{ color: 'green.500' }}>
                      <Icon as={FaWhatsapp} color="gray.500" />
                      <Text fontSize="sm">+919473421755</Text>
                    </HStack>
                  </Link>
                  {/* Hours */}
                  <HStack spacing={3} color="gray.700">
                    <Icon as={FaClock} color="gray.500" />
                    <Text fontSize="sm">24/7 Support Services</Text>
                  </HStack>
                </VStack>

                {/* Social Media Links from NavbarTopFirstt */}
                <Divider />
                <Text fontSize="sm" fontWeight="bold" color="gray.500">Connect With Us</Text>
                <HStack spacing={4}>
                  <Link href="https://www.linkedin.com/company/orivanta-ai/" isExternal>
                    <Icon as={FaLinkedin} boxSize={5} color="gray.500" _hover={{ color: 'blue.500' }} />
                  </Link>
                  <Link href="https://www.facebook.com/" isExternal>
                    <Icon as={FaFacebook} boxSize={5} color="gray.500" _hover={{ color: 'blue.500' }} />
                  </Link>
                  {/* Add other social media icons if needed */}
                </HStack>

              </VStack>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </Flex>
    </Box>
  );
}

export default NavbarTopSecond; 